import * as nodeService from '../../api/modules/nodeService';
import type { GraphHostMessage, INodeGraphConnection } from './NodeServiceGraphChannel';

/** Production adapter shares Host's existing authenticated socket and never queues graph traffic. */
export class IncumbentNodeGraphConnection implements INodeGraphConnection {
  public send(message: GraphHostMessage): boolean { return nodeService.sendMessage(message, { queueOnFailure: false }); }
  public connected(): boolean { return nodeService.isNodeServiceConnected(); }
  public subscribe(action: string, listener: (message: GraphHostMessage) => void): () => void {
    nodeService.onMessage(action, listener); return () => nodeService.offMessage(action, listener);
  }
  public onConnection(listener: (connected: boolean) => void): () => void { return nodeService.nodeServiceLifecycle.subscribe(listener); }
}
